module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographic Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesdata.region),
      expression: "salesdata.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salesdata, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getSite]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("G.A is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.site),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesdata.site),
      expression: "salesdata.site"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "site"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.salesdata, "site", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getDispenserCount]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(" Select Location")]), _vm._v(" "), _vm._l((_vm.site_list), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "count": item.dispenserCount
      },
      domProps: {
        "value": item._id
      }
    }, [_vm._v("\n                                            " + _vm._s(item.siteName) + "\n                                        ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "site",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportedDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Report Date")]), _vm._v(" "), _c('VueCtkDateTimePicker', {
    attrs: {
      "id": "reportedDate",
      "required": "",
      "lang": "en",
      "name": "reportedDate",
      "input-class": "form-control",
      "width": "100%",
      "format": "MM-DD-YYYY hh:mm a"
    },
    model: {
      value: (_vm.salesdata.reportedDate),
      callback: function($$v) {
        _vm.$set(_vm.salesdata, "reportedDate", $$v)
      },
      expression: "salesdata.reportedDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportedDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Date is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Sales Data")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "Car"
    }
  }, _vm._l((this.totalDispenser), function(dispenser_number, i) {
    return _c('div', {
      staticClass: "col-sm-12",
      attrs: {
        "id": "dispenser"
      }
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('br'), _vm._v(" "), _c('label', [_vm._v(" Dispenser " + _vm._s(dispenser_number) + " ")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle A Opening")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dispenserFormData['nozzleAOpening'][i]),
        expression: "dispenserFormData['nozzleAOpening'][i]"
      }],
      ref: "nozzleAOpening",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "name": "a",
        "required": ""
      },
      domProps: {
        "value": (_vm.dispenserFormData['nozzleAOpening'][i])
      },
      on: {
        "change": function($event) {
          _vm.fillNext($event, i, 'nozzleAOpening')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dispenserFormData['nozzleAOpening'], i, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle A Closing")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dispenserFormData['nozzleAClosing'][i]),
        expression: "dispenserFormData['nozzleAClosing'][i]"
      }],
      ref: "nozzleAClosing",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": this.refs,
        "name": "b",
        "required": "",
        "disabled": _vm.disabledInput
      },
      domProps: {
        "value": (_vm.dispenserFormData['nozzleAClosing'][i])
      },
      on: {
        "change": function($event) {
          _vm.compareValue($event, i, 'nozzleAClosing')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dispenserFormData['nozzleAClosing'], i, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Meter Jump A")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dispenserFormData['nozzleAMeterJump'][i]),
        expression: "dispenserFormData['nozzleAMeterJump'][i]"
      }],
      ref: "nozzleAMeterJump",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "disabled": _vm.disabledInput
      },
      domProps: {
        "value": (_vm.dispenserFormData['nozzleAMeterJump'][i])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dispenserFormData['nozzleAMeterJump'], i, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle B Opening")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dispenserFormData['nozzleBOpening'][i]),
        expression: "dispenserFormData['nozzleBOpening'][i]"
      }],
      ref: "nozzleBOpening",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": ""
      },
      domProps: {
        "value": (_vm.dispenserFormData['nozzleBOpening'][i])
      },
      on: {
        "change": function($event) {
          _vm.fillNext($event, i, 'nozzleBOpening')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dispenserFormData['nozzleBOpening'], i, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Nozzle B closing")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dispenserFormData['nozzleBClosing'][i]),
        expression: "dispenserFormData['nozzleBClosing'][i]"
      }],
      ref: "nozzleBClosing",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "disabled": _vm.disabledInput
      },
      domProps: {
        "value": (_vm.dispenserFormData['nozzleBClosing'][i])
      },
      on: {
        "change": function($event) {
          _vm.compareValue($event, i, 'nozzleBClosing')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dispenserFormData['nozzleBClosing'], i, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Meter Jump B")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dispenserFormData['nozzleBMeterJump'][i]),
        expression: "dispenserFormData['nozzleBMeterJump'][i]"
      }],
      ref: "nozzleBMeterJump",
      refInFor: true,
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "disabled": _vm.disabledInput
      },
      domProps: {
        "value": (_vm.dispenserFormData['nozzleBMeterJump'][i])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.dispenserFormData['nozzleBMeterJump'], i, $event.target.value)
        }
      }
    })])])])
  })), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-left"
  }, [_c('br'), _vm._v(" "), _c('label', [_vm._v(" Total Quantity")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.salesdata.totalValue),
      expression: "salesdata.totalValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "totalValue"
    },
    domProps: {
      "value": (_vm.salesdata.totalValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.salesdata, "totalValue", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'salesdata'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-5 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createSaleData
    }
  }, [_vm._v("Add Sales Status")])], 1)], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0066bbea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0066bbea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Salesdata/SalesdataCreate.vue
// module id = 2242
// module chunks = 0